import React, {useContext, useEffect, useState} from "react";
import {Col, Container, Form, Row} from "react-bootstrap";
import {
    dateToString,
    getCurBusDate, getMaxYear4DigitsFormat,
    getMinPermissibleBusDate,
    pickerDateFormatToDate,
    yearMonthDayToPickerDateFormat
} from "utils/FormatUtils";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE} from "./context/AssetTransferContext";
import {ToastContext} from "context/Toast";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {FilterContext} from "layouts/SidePanelLayout";
import {isValidDate, validateValueOnRegex} from "../../utils/RegexUtils";
import {VALIDATION_IN_JS} from "../../utils/Constants";
import {getAllErrorValuesAsString, updateAssetTransfersFilterFormErrors} from "../../utils/ErrorUtils";
import {AssetTransferContext} from "./context";

export default function AssetTransferFilter() {

    const {
        assetTransferPanelFilterState,
        setAssetTransferPanelFilterState,
        assetTransferCaptureDisplayState,
        setAssetTransferCaptureDisplayState,
        clearAssetTransferSearchAndLoadTradingHome,
        setShowGridToolbar,
        setHeaderCheckedboxChecked,
        setSelectedRows,
        setSelectedAnyCheckbox,
        setColumnState, setAmendClicked
    } = useContext(AssetTransferContext);
    const {entityAccountsNoSwap, clearEntityAccounts, setManagerAndAccountDetails, validateEntityAccountSearch, paramBadgeInfo, populateDefaultEntity, entityAccountsOptionsNoSwap} = useContext(EntityAccountsContext);

    const {makePostRequest} = useContext(SecurityContext);
    const {alert, error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState({});
    const [accountOptional, setAccountOptional] = useState(true);
    const {showFilter, setShowFilter} = useContext(FilterContext);
    const [actualTransfers, setActualTransfers] = useState(false);


    const handleSearchOnChange = (e) => {
        let assetTransferPanelFilterStateUpdated = JSON.parse(JSON.stringify(assetTransferPanelFilterState));
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        assetTransferPanelFilterStateUpdated[targetName] = targetValue;
        setAssetTransferPanelFilterState(assetTransferPanelFilterStateUpdated);

        updateAssetTransfersFilterFormErrors(targetName, targetValue,
            formErrors, setFormErrors, assetTransferPanelFilterState);
    }

    const handleSearchClear = (e) => {
        clearEntityAccounts(true, true, true);
        clearAssetTransferSearchAndLoadTradingHome();
        setAccountOptional(true)
    }

    useEffect(() => {
        populateDefaultEntity(true,true)
    }, [entityAccountsOptionsNoSwap])


    useEffect(() => {
        if (ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE === assetTransferCaptureDisplayState.currentPage) {
            setManagerAndAccountDetails(assetTransferCaptureDisplayState.assetTransferActivitiesSearch.managerId, assetTransferCaptureDisplayState.assetTransferActivitiesSearch.managerName,
                assetTransferCaptureDisplayState.assetTransferActivitiesSearch.accountId??'', assetTransferCaptureDisplayState.assetTransferActivitiesSearch.accountName??'',
                assetTransferCaptureDisplayState.assetTransferActivitiesSearch.accountCode, true, true);

            let assetTransferPanelFilterStateUpdated = {...assetTransferPanelFilterState};
            assetTransferPanelFilterStateUpdated.status = assetTransferCaptureDisplayState.assetTransferActivitiesSearch.status;
            assetTransferPanelFilterStateUpdated.startDate = yearMonthDayToPickerDateFormat(assetTransferCaptureDisplayState.assetTransferActivitiesSearch.startDate);
            assetTransferPanelFilterStateUpdated.endDate = yearMonthDayToPickerDateFormat(assetTransferCaptureDisplayState.assetTransferActivitiesSearch.endDate);
            setAssetTransferPanelFilterState(assetTransferPanelFilterStateUpdated);
        }

    }, [assetTransferCaptureDisplayState.currentPage]);

    const validateSearch = ()=>{
        const {startDate, endDate} = assetTransferPanelFilterState;
        let errors = {}
        errors = validateEntityAccountSearch(false, true);

        if(!startDate || !isValidDate(startDate))
            errors['startDate'] = 'Please input start date'

        if(!endDate || !isValidDate(endDate))
            errors['endDate'] = 'Please input end date'

        if (startDate && endDate){
            let startDateD = new Date(startDate).getTime();
            let endDateD = new Date(endDate).getTime();

            if (startDateD > endDateD){
                errors['startDate'] = 'Please ensure that the start date is before the end date'
                errors['endDate'] = 'Please ensure that the start date is before the end date'
            }
        }


        if (dateToString(startDate) > getCurBusDate())
            errors['startDate'] = `Start date should be less than or equal to ${pickerDateFormatToDate(getCurBusDate())}`;
        if (startDate && (dateToString(startDate) < getMinPermissibleBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or after ${pickerDateFormatToDate(getMinPermissibleBusDate())}`;

        if (startDate &&  (dateToString(startDate) > getCurBusDate()))
            errors['startDate'] = `Please ensure that the start date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;

        // // let errorsRegex = validateStatus()
        // if (errorsRegex){
        //     errors = {...errors, ...errorsRegex}
        // }
        return errors
    }

    const handleSearchClick = (e) => {
        e.preventDefault();
        setAmendClicked(false)
        let errors = {}
        if (VALIDATION_IN_JS) {
            errors = validateSearch()
        }
        if(Object.keys(errors).length > 0){
            setFormErrors(errors)
            return
        }

        const searchCriteria = {
            managerId: entityAccountsNoSwap.managerId,
            subManagerId: entityAccountsNoSwap.subManagerId,
            status: assetTransferPanelFilterState.status,
            accountId: entityAccountsNoSwap.accountId,
            startDate: dateToString(assetTransferPanelFilterState.startDate),
            endDate: dateToString(assetTransferPanelFilterState.endDate)
        }

        setShowFilter(!showFilter)

        const onSuccessResponse = (response) => {

            let assetTransferCaptureDisplayStateShowActivities = {...assetTransferCaptureDisplayState};
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.status = searchCriteria.status;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.startDate = searchCriteria.startDate;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.endDate = searchCriteria.endDate;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.managerId = searchCriteria.managerId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.subManagerId = searchCriteria.subManagerId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountId = searchCriteria.accountId;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.managerName = entityAccountsNoSwap.managerName;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.subManagerName = entityAccountsNoSwap.subManagerNameShort;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountName = entityAccountsNoSwap.accountName;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.accountCode = entityAccountsNoSwap.accountCode;
            assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.badgeInfo = paramBadgeInfo(true);

            if (!response.data || response.data.length === 0) {
                assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.resData = [];
                alert('No AssetTransfer activities found matching your search');
            } else {
                assetTransferCaptureDisplayStateShowActivities.assetTransferActivitiesSearch.resData = response.data;
            }
            setShowGridToolbar(response.data && response.data.length > 0)
            assetTransferCaptureDisplayStateShowActivities.isSavedTradeList = false;
            assetTransferCaptureDisplayStateShowActivities.currentPage = ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE;
            setAssetTransferCaptureDisplayState(assetTransferCaptureDisplayStateShowActivities);
            setColumnState(null);

        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("Error occurred with searching assetTransfer activities",errorMsg);
            error("Error occurred with searching assetTransfer activities " + errorMsg);
        }

        makePostRequest(searchCriteria,
            URL.ASSET_TRANSFER_SEARCH_URL, onSuccessResponse, onErrorResponse);

        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false)
        setSelectedRows([]);
    };

    return (<>
        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-none d-md-block">Search</h2>
                <Row>
                    <EntityAccountsComponent accountOptional={accountOptional} hideSwapLob={true} />
                    <Col md={12}>
                        <Form.Group controlId="formGridStatus" className={'td-select'} >
                            <Form.Label className="filter-input-label">Status</Form.Label>
                            <Form.Control as="select" name="status"
                                          value={assetTransferPanelFilterState.status}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.status}>
                                <option value='ALL'>ALL</option>
                                <option value='ERROR'>ERROR</option>
                                <option value='ERROR - TD TO AMEND'>ERROR - TD TO AMEND</option>
                                <option value='SUBMITTED'>SUBMITTED</option>
                                <option value='PROCESSING'>PROCESSING</option>
                                <option value='CANCELLED'>CANCELLED</option>
                                <option value='REJECTED'>REJECTED</option>
                                <option value='PROCESSED - PENDING SETT'>PROCESSED - PENDING SETT</option>
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.status}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group
                            controlId="assetTransferCaptureDisplayState.assetTransferActivitiesSearch.startDate"
                            md={6}>
                            <Form.Label className="filter-input-label">Start Date *</Form.Label>
                            <Form.Control type="date" name="startDate"
                                          value={assetTransferPanelFilterState.startDate}
                                          onChange={handleSearchOnChange}
                                          max={getMaxYear4DigitsFormat()}
                                          isInvalid={!!formErrors.startDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.startDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={6} md={12}>
                        <Form.Group
                            controlId="assetTransferCaptureDisplayState.assetTransferActivitiesSearch.endDate"
                            md={6}>
                            <Form.Label className="filter-input-label">End Date *</Form.Label>
                            <Form.Control type="date" name="endDate"
                                          value={assetTransferPanelFilterState.endDate}
                                          onChange={handleSearchOnChange}
                                          max={getMaxYear4DigitsFormat()}
                                          isInvalid={!!formErrors.endDate}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.endDate}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" href="#"
                                onClick={handleSearchClick}>View Activities
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3"
                                href="#" onClick={handleSearchClear}>Clear
                        </button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>);

}
